import type { Role } from '@/lib/auth/types';

/** Roles that can move between the full office platform and the crew route UI. */
export function canAccessFullPlatform(role: Role | null | undefined): boolean {
  return role === 'admin' || role === 'manager' || role === 'dispatcher';
}
